import React from 'react';
import { ModalX } from '../../../components';
import { Button, Input, Option, Select, Spinner } from '@material-tailwind/react';
import { useAddUser, useUpdateUser } from '../../../custom-hooks/use-users';
import { convertToPresentableText, NotifyError } from '../../../utils/functions';
import { STATIC_USER_ROLES, STATIC_USER_ROLES_ENUM } from '../../../utils/enums';


// Functional component
const UserFormModal = ({
    isOpen,
    onClose,
    isUpdating,
    updatingUserId,
    defaultData,

}) => {
    // 
    const addUserMutation = useAddUser();
    const updateUserMutation = useUpdateUser();

    // State variables
    const [formData, setFormData] = React.useState(defaultData);

    // Handle form input change
    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({
            ...prev,
            [name]: value,
        }));
    };

    const handleSelectChange = (name, value) => {
        setFormData((prev) => ({
            ...prev,
            [name]: value,
        }));
    };

    // Handle form submission
    const handleFormSubmit = async (e) => {
        e.preventDefault();
        try {
            if (isUpdating) {
                // Update user logic
                const updatedUser = {
                    email: formData.email,
                    name: formData.name,
                    role: formData.role,
                    cnic: formData.cnic,
                    phone: formData.phone
                };
                await updateUserMutation.mutateAsync({
                    userId: updatingUserId,
                    data: updatedUser
                });
            } else {
                // Add new user logic
                const newUser = {
                    email: formData.email,
                    password: formData.password,
                    name: formData.name,
                    role: formData.role,
                    cnic: formData.cnic,
                    phone: formData.phone
                };
                await addUserMutation.mutateAsync(newUser);
                onClose(false);
                setFormData(defaultData);
            }
        } catch (error) {
            console.error(error);
            NotifyError(error.response.data.message, error);
        }
    };
    return (
        <ModalX
            isOpen={isOpen}
            onClose={() => onClose(false)}
            title={isUpdating ? "Update User" : "Add User"}
            maxWidth="md"
        >
            <form onSubmit={handleFormSubmit}>
                <div className="space-y-4">
                    <Input
                        label="Full Name"
                        name="name"
                        value={formData.name}
                        onChange={handleInputChange}
                        required
                    />
                    <Input
                        label="Email Address"
                        name="email"
                        type="email"
                        value={formData.email}
                        onChange={handleInputChange}
                        required
                    />
                    <Input
                        label="CNIC"
                        name="cnic"
                        value={formData.cnic}
                        onChange={handleInputChange}
                        required
                    />
                    <Input
                        label="Phone Number"
                        name="phone"
                        value={formData.phone}
                        onChange={handleInputChange}
                        required
                    />
                    {!isUpdating && (
                        <Input
                            label="Password"
                            name="password"
                            type="password"
                            value={formData.password}
                            onChange={handleInputChange}
                            required
                        />
                    )}
                    <Select
                        label="Role"
                        value={formData.role}
                        onChange={(value) => handleSelectChange("role", value)}
                    >
                        {
                            STATIC_USER_ROLES_ENUM.filter(role => role !== STATIC_USER_ROLES.USER).map((role) => (
                                <Option key={role} value={role}>{convertToPresentableText(role)}</Option>
                            ))
                        }
                    </Select>
                </div>
                <div className="mt-4 flex justify-end space-x-2">
                    <Button
                        onClick={() => onClose(false)}
                        className="rounded-full"
                        variant="text"
                    >
                        Cancel
                    </Button>
                    <Button disabled={updateUserMutation.isLoading} type="submit" className="rounded-full flex gap-2">
                        {updateUserMutation.isLoading && <Spinner className='w-4 h-4' />}{isUpdating ? "Update" : "Add"}
                    </Button>
                </div>
            </form>
        </ModalX>
    );
};

export default UserFormModal;